import './Footer.scss';
import { links } from '../../helpers/constants';

type ContactLinkProps = { href: string, src: any, alt: string, index: number };

const ContactLink = ({ href, src, alt, index }: ContactLinkProps): JSX.Element =>
(
    <a target="_blank" rel="noopener noreferrer" href={href} style={{animationDelay: `${1000 + index * 100}ms`}}><img src={src} alt={alt}></img></a>
)

const Footer = (): JSX.Element =>
(
    <div className="links">
        {
            links.map((e, i) =>
            (
                <ContactLink key={i} {...e} index={i} />
            ))
        }
    </div>
)

export default Footer;
